import { useTranslation } from 'react-i18next';

import { Alert } from '@/components/atoms/Alert';
import { Button } from '@/components/atoms/Buttons';
import { Spinner } from '@/components/atoms/Spinner';
import { confirm } from '@/components/molecules/ConfirmDialog';

import styles from './CurrentBioscopePlacement.module.scss';

export interface CurrentBioscopePlacementProps {
    loading: boolean;
    error: boolean;
    errorText?: string;
    title: string;
    client: {
        id: number;
        name: string;
    };
    onUpdateClientIsOpen?: (isOpen: boolean) => void;
    /** Runs inside the confirmation, which waits for it and shows a failure. */
    deleteLastBioscopeMove?: () => Promise<unknown>;
    moveBioscope?: () => void;
}

function CurrentBioscopePlacement({
    loading,
    error,
    errorText,
    title,
    client,
    deleteLastBioscopeMove,
    moveBioscope,
}: CurrentBioscopePlacementProps) {
    const { t } = useTranslation();
    const clientName = client ? client.name : t('common.labels.none');

    return (
        <div className={styles.currentbioscopeplacement}>
            <h2>{t(title)}</h2>
            <p>{clientName}</p>
            {loading ? <Spinner /> : null}
            {error ? (
                <Alert tone="danger">
                    {errorText ?? t('bioscopeDetail.placement.errorFallback')}
                </Alert>
            ) : null}
            <div>
                <Button name="bioscope_move" onClick={moveBioscope}>
                    {t('common.actions.move')}
                </Button>
                <Button
                    variant="danger"
                    name="bioscope_delete_last_move"
                    onClick={() =>
                        deleteLastBioscopeMove &&
                        confirm({
                            title: t('common.actions.deleteLastMove'),
                            message: t('bioscopeDetail.placement.confirmDeleteLastMove'),
                            confirmLabel: t('common.actions.delete'),
                            errorFallback: t('bioscopeDetail.placement.updateError'),
                            onConfirm: deleteLastBioscopeMove,
                        })
                    }>
                    {t('common.actions.deleteLastMove')}
                </Button>
            </div>
        </div>
    );
}

export default CurrentBioscopePlacement;
export { CurrentBioscopePlacement };
